(() => {
  const root = document.documentElement;
  const main = document.querySelector('#MainContent');
  if (!(main instanceof HTMLElement) || root.dataset.daoTalismanField === 'true') return;

  root.dataset.daoTalismanField = 'true';
  root.classList.add('dao-talisman-ready');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const field = document.createElement('div');
  field.className = 'dao-talisman-field';
  field.setAttribute('aria-hidden', 'true');

  const glyphs = ['符', '道', '玄', '靈', '炁', '清', '真', '一'];
  const count = window.innerWidth < 750 ? 8 : 18;

  for (let index = 0; index < count; index += 1) {
    const mark = document.createElement('span');
    mark.textContent = glyphs[index % glyphs.length];
    mark.style.setProperty('--dao-talisman-x', `${(index * 37) % 100}vw`);
    mark.style.setProperty('--dao-talisman-y', `${(index * 23) % 100}vh`);
    mark.style.setProperty('--dao-talisman-size', `${18 + (index % 6) * 7}px`);
    mark.style.setProperty('--dao-talisman-delay', `${index * -0.9}s`);
    mark.style.setProperty('--dao-talisman-duration', `${6.5 + (index % 5) * 1.1}s`);
    field.append(mark);
  }

  document.body.prepend(field);
})();
